import { connect } from 'react-redux';
import {
  getContractsByStock,
  deleteContract,
  addContract,
  updateContract
} from '../../../store/actions/contract';
import ContractsAdmin from './ContractsAdmin';

const mapStateToProps = ({
  contractReducer,
  stockReducer
}) => ({
  contractReducer,
  stockReducer
});
const mapDispatchToProps = {
  getContractsByStock,
  deleteContract,
  addContract,
  updateContract
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractsAdmin);
